import React, { Component } from 'react';
import Proptypes from 'prop-types';
import Paper from 'material-ui/Paper';
import Typography from 'material-ui/Typography';
import { withStyles } from 'material-ui/styles';

const styles = theme =>({
  root: {
    flex: '1 0 100%',
    margin: theme.spacing.unit,
  },
  section: {
    padding: 16,
    marginTop: theme.spacing.unit * 3,
  },
  super: {
    verticalAlign: 'super',
    fontSize: '0.25em'
  },
  headline: {
    color: theme.palette.primary.main
  }
});

const features = {
  title: 'What is',
  messages: [
    'Web based tool, no need to download or install.',
    'Up-to-date constructions and DK / DF data on ITEQ laminates.',
    'Inbuilt pressed thickness calculator and warnings for insufficient prepreg layers.',
    'Intuitive stackup design editor and impedance calculators.',
    'Save stackup design files locally, or share and import directly into ITEQ Stackup Pro',
    'Print and share material data or completed stackup designs as PDF documents.',
    'Technical support from ITEQ’s Design for Signal Integrity & Cost (DFSIC) team.'
  ]
};

const benefits = {
  title: 'Who benefits from',
  messages: [
  'ITEQ Stackup Pro will be useful to fabricators, design engineers and marketing / sales personnel.',
  'The web-based and intuitive design interface provides a convenient, and easy to use methodology for building high layer count PCBs with up to date material constructions.' 
  ]
};

const differences = {
  title: 'What differentiates',
  messages: [
    'The web interface offers the look and functionality of a desktop application without the hassle of software installation.',
    'Multiple users and log-in to the same stackup design, and share information with multiple stake holders directly through the interface.',
    'This seamless communication can eliminate translation errors during the review process.'
  ]
};

export class AboutPage extends Component{
  render(){
    const { classes } = this.props;

    return (
      <div data-title="About" className={classes.root}>
        <Paper>
          {[features, benefits, differences].map(section => (
            <div key={section.title} className={classes.section}>
              <Typography variant="headline" className={classes.headline}>
                {section.title}{' '}ITEQ Stackup Pro<span className={classes.super}>TM</span>
              </Typography>
              <ul>
                {section.messages.map((feature, index) => (
                  <li key={index}>
                    <Typography variant="subheading" paragraph={true}>
                      {feature}
                    </Typography>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </Paper>
      </div>
    );
  }
}

AboutPage.proptypes = {
  classes: Proptypes.object.isrequired,
  classname: Proptypes.string,
}

export default withStyles(styles)(AboutPage);



// WEBPACK FOOTER //
// ./src/components/AboutPage/index.js